module.exports = __webpack_public_path__ + "vue/img/ml.c4ca061b.jpg";